import html2canvas from 'html2canvas';

export const convertBase64Image = (data: string, type: string): string =>
  `data:${type};base64,${data}`;

/**
 * Generate thumbnail image from HTML element
 * @param element - HTML element to capture
 * @returns Promise<File> - PNG image file with transparent background
 */
export const generateThumbnailFromElement = async (
  element: HTMLElement,
): Promise<File> => {
  const canvas = await html2canvas(element, {
    backgroundColor: 'transparent',
    scale: 2, // Higher quality
    logging: false,
    useCORS: true,
    allowTaint: true,
  });

  // Convert to blob then to file directly without resizing
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) {
          const file = new File([blob], 'thumbnail.png', {
            type: 'image/png',
          });
          resolve(file);
        } else {
          reject(new Error('Failed to create blob from canvas'));
        }
      },
      'image/png',
    );
  });
};
